module.exports = __webpack_public_path__ + "assets/c962876a8892af69417af39f6ecea8e8.mp3";